import React from 'react';
import Tooltip from '@catalogo/theme-tooltip-box';
import { useDebounce } from '@catalogo/core-hooks/debounce';
import { Acom } from './acom';
import { StampComponentProps } from '../../../types';
import { Shop } from './shop';
import { Skoo } from './skoo';
import { Suba } from './suba';
import { TooltipContent, StampWrapper, TooltipText } from './Styled';

const Stamp = (props: StampComponentProps) => {
  const { brand, isSkoob } = props;
  const [showTooltip, setShowTooltip] = React.useState(false);

  const debouncedTooltip = useDebounce(showTooltip, 500);
  const getStamp = () => {
    if (isSkoob) {
      return <Skoo />;
    }

    switch (brand) {
      case 'acom':
        return <Acom />;
      case 'suba':
        return <Suba />;
      case 'shop':
        return <Shop />;
      default:
        return null;
    }
  };

  const getTooltipText = () => {
    if (isSkoob) {
      return 'Quem fez essa resenha compartilhou a opinião pelo Skoob, uma rede social para quem ama livros.';
    }

    switch (brand) {
      case 'acom':
        return 'Quem fez essa avaliação comprou o produto na Americanas.';
      case 'suba':
        return 'Quem fez essa avaliação comprou o produto no Submarino.';
      case 'shop':
        return 'Quem fez essa avaliação comprou o produto no Shoptime.';
      default:
        return null;
    }
  };

  return (
    <div>
      <StampWrapper
        onMouseEnter={() => (!showTooltip ? setShowTooltip(true) : null)}
        onMouseLeave={() => (showTooltip ? setShowTooltip(false) : null)}
      >
        {getStamp()}
        <Tooltip
          width="400px"
          show={debouncedTooltip}
          positionType="absolute"
          color="#fff"
          arrowSize={10}
          arrowPosition="10%"
          zIndex={9}
          top="34px"
          left="0px"
          onMouseEnter={() => (!showTooltip ? setShowTooltip(true) : null)}
          onMouseLeave={() => (showTooltip ? setShowTooltip(false) : null)}
          hasOverlay={false}
          right={undefined}
          bottom={undefined}
          marginTop="8px"
        >
          <TooltipContent>
            <TooltipText>{getTooltipText()}</TooltipText>
          </TooltipContent>
        </Tooltip>
      </StampWrapper>
    </div>
  );
};

Stamp.defaultProps = {
  brand: '',
  isSkoob: false,
};

export default Stamp;
export { Stamp };
